/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// For some reason some libraries use global on the frontend.
// Just define it on window as a ref to window, problem solved.
window.global = window;
